import React from "react";
import { Text, View } from "@react-pdf/renderer";
import PrintApplicationStyles from "../PrintApplicationStyles";
import { formatPrintDate } from "../formatPrintDate";

const PrintSection4 = ({ section4 }) => {
  return (
    <>
      <Text break style={PrintApplicationStyles.sectionheader}>
        Section 4 – Company Directorship Details
      </Text>
      <View style={PrintApplicationStyles.inputtable}>
        <View style={PrintApplicationStyles.inputRow}>
          <Text style={PrintApplicationStyles.inputLabel}>
            4.1 Have you ever held any company Directorships or Partnerships
            whether current or not? (Please ensure you include all Directorships
            or Partnerships you have held at any time.) If yes, please provide
            details.
          </Text>
          <View style={PrintApplicationStyles.inputBox}>
            <Text>
              {section4?.heldDirectorships === true
                ? "Yes"
                : section4?.heldDirectorships === false
                  ? "No"
                  : section4?.heldDirectorships === "N/A"
                    ? "Not Applicable"
                    : ""}
            </Text>
          </View>
        </View>
        <View style={PrintApplicationStyles.inputRow}>
          <Text style={PrintApplicationStyles.inputLabel}>
            If multiple directorships are held at the same time, you must ensure
            that all relationships are disclosed. You should also provide a
            breakdown of the time committed to each directorship.
          </Text>
        </View>
      </View>
      <View style={PrintApplicationStyles.table}>
        <View style={PrintApplicationStyles.tableRow}>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Name of firm
          </Text>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Nature of business
          </Text>

          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Country incorporation started
          </Text>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Directorship Start and End Dates
          </Text>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            If this Directorship is active, please confirm how many hours per month you
             dedicate to it.
          </Text>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Date Directorship
          </Text>
        </View>
        {section4?.directorshipDetails &&
        Object.keys(section4.directorshipDetails).length > 0
          ? Object.values(section4.directorshipDetails).map(
              (directorship, index) => (
                <View style={PrintApplicationStyles.tableRow} key={index}>
                  <Text style={PrintApplicationStyles.tableCell}>
                    {directorship?.nameOfFirm || ""}
                  </Text>
                  <Text style={PrintApplicationStyles.tableCell}>
                    {directorship?.natureOfBusiness || ""}
                  </Text>
                  <Text style={PrintApplicationStyles.tableCell}>
                    {directorship?.countryIncorporationStarted || ""}
                  </Text>

                  <Text style={PrintApplicationStyles.tableCell}>
                    {formatPrintDate(directorship?.startDate)}
                    {(formatPrintDate(directorship?.endDate) ? " to " + formatPrintDate(directorship?.endDate) : "")}
                  </Text>
                  <Text style={PrintApplicationStyles.tableCell}>
                    {directorship?.timeSpent || ""}
                  </Text>
                  <Text style={PrintApplicationStyles.tableCell}>
                    {formatPrintDate(directorship?.dateDirectorship)}
                  </Text>
                </View>
              ),
            )
          : null}
      </View>

      <View style={PrintApplicationStyles.inputtable}>
        <View style={PrintApplicationStyles.tableRow}>
          <View style={PrintApplicationStyles.inputSection}>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Will the above Directorship or Partnerships continue?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section4?.futureIntentions === true
                    ? "Yes"
                    : section4?.futureIntentions === false
                      ? "No"
                      : section4?.futureIntentions === "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                If no, what has happened/is happening to them?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section4?.ifNoDetails || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                If yes, please provide details of your future intentions and the
                nature of your responsibilities.
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section4?.ifYesDetails || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Do you have any financial liabilities outstanding regarding this
                Directorship/Partnership or have you ever signed a Deed of
                Guarantee?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section4?.financialLiabilities === true
                    ? "Yes"
                    : section4?.financialLiabilities === false
                      ? "No"
                      : section4?.financialLiabilities === "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Additional Information
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section4?.additionalInformation || ""}</Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};

export default PrintSection4;
